import { render, staticRenderFns } from "./BuildingFieldReferenceList.vue?vue&type=template&id=4d91d8b4&scoped=true&"
import script from "./BuildingFieldReferenceList.vue?vue&type=script&lang=js&"
export * from "./BuildingFieldReferenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d91d8b4",
  null
  
)

export default component.exports